export class EventOverview {

    public EventID: number = -1;
    public PrimaryAuditResultID: number = -1;
    public CustomerLocationID: number = -1;
    public LocationName: string = "";
    public LocationQuestion: string = "";
    public DateQuestion: string = "";
    public TypeQuestion: string = "";
    public SummaryQuestion: string = "";
    public RiskQuestion: string = "";
    public EventStatusID: number = -1;
    public EventStatus: string = "";
    public UserCreated: string = "";
    public UserIDCreated: number = -1;
    public DateCreated: Date = new Date();
    constructor(values: Object = {}) {
        Object.assign(this, values);
        if (values.hasOwnProperty("DateCreated")){
            this.DateCreated = new Date((values as EventOverview)["DateCreated"]);
        }
    }
}